var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "leftCardContainer" },
    [
      _c("div", { staticClass: "rightSideTitleActions" }, [
        _c("span", { staticClass: "leftTitle" }, [
          _vm._v(_vm._s(_vm.$t("Warehouse")))
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "actionsContainer" },
          [
            _c(
              "div",
              { staticClass: "searchContainer" },
              [
                _c("v-icon", [_vm._v(" search ")]),
                _vm._v(" "),
                _c("InputField", {
                  attrs: {
                    inputType: "text",
                    value: _vm.search,
                    placeholder: _vm.$t("Search"),
                    inputStyle: {
                      borderRadius: "0px",
                      width: "130px",
                      borderTop: "none",
                      borderRight: "none",
                      borderLeft: "none",
                      borderBottom: "1px solid rgba(118, 118, 118, 0.50)"
                    }
                  },
                  on: {
                    input: function($event) {
                      return _vm.handleSearch($event)
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("CustomButton", {
              attrs: {
                icon: "delete",
                width: "20px",
                height: "20px",
                iconSize: 12,
                disabled: _vm.selectedRows.length === 0,
                buttonStyling: {
                  padding: "8px",
                  marginRight: "5px",
                  borderRadius: "4px"
                }
              },
              on: { buttonClick: _vm.openDeleteDialog }
            }),
            _vm._v(" "),
            _c("CustomButton", {
              attrs: {
                icon: "download",
                width: "20px",
                height: "20px",
                iconSize: 12,
                buttonStyling: {
                  padding: "8px",
                  marginRight: "5px",
                  borderRadius: "4px"
                },
                disabled: _vm.downloadDisable,
                isLoading: _vm.downloadDisable
              },
              on: { buttonClick: _vm.handleDownload }
            }),
            _vm._v(" "),
            _c("CustomButton", {
              attrs: {
                icon: "cloud_upload",
                width: "20px",
                height: "20px",
                iconSize: 12,
                buttonStyling: {
                  padding: "8px",
                  marginRight: "5px",
                  borderRadius: "4px"
                }
              },
              on: { buttonClick: _vm.handleCloudDownload }
            }),
            _vm._v(" "),
            _c("CustomButton", {
              attrs: {
                icon: "add",
                width: "20px",
                height: "20px",
                iconSize: 12,
                disabled: _vm.userIsCreatingOrEditingData,
                buttonStyling: {
                  padding: "8px",
                  marginRight: "5px",
                  borderRadius: "4px"
                }
              },
              on: { buttonClick: _vm.handleAdd }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tabsContainer" },
        [
          _c("Tabs", {
            attrs: { activeTab: _vm.activeTab, tabs: _vm.tabs },
            on: { startTabChange: _vm.handleTabChange }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tableDivContainer" },
        [
          _c("Table", {
            attrs: {
              checkbox: true,
              loading: _vm.loading,
              headers: _vm.headers,
              items: _vm.materials,
              sortable: true,
              emitRowClickBusEvent: !_vm.userIsCreatingOrEditingData
            },
            on: {
              onScrollBottom: _vm.onScrollBottom,
              onScrollTop: _vm.onScrollTop,
              sortClick: _vm.onSortClick,
              selectedRows: function($event) {
                return _vm.onCheckboxClick($event)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("DialogContent", {
        attrs: {
          isOpen: _vm.dialog,
          isPersistent: false,
          onClose: _vm.closeDialog
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _c("div", { staticStyle: { height: "100%" } }, [
                  _c(
                    "div",
                    { staticClass: "tabs-custom" },
                    [
                      _c("Tabs", {
                        staticStyle: { display: "flex", "align-items": "left" },
                        attrs: {
                          tabs: _vm.tabsDialog,
                          activeTab: _vm.activeTabDialog
                        },
                        on: { startTabChange: _vm.handleTabChangeDialog }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.activeTabDialog === 0
                    ? _c(
                        "div",
                        { staticClass: "tabs-content-custom" },
                        [
                          _c("span", { staticClass: "span-custom" }, [
                            _vm._v("Material Family")
                          ]),
                          _vm._v(" "),
                          _c("InputField", {
                            attrs: {
                              inputStyle: {
                                backgroundColor: "white"
                              },
                              inputType: "text",
                              value: "All Families",
                              size: "large",
                              inputDisabled: true
                            }
                          }),
                          _vm._v(" "),
                          _c("InputField", {
                            attrs: {
                              inputStyle: {
                                color: "#767676 !important"
                              },
                              inputType: "file",
                              size: "large",
                              fileTypes: _vm.fileTypes,
                              value: _vm.file
                            },
                            on: {
                              input: function($event) {
                                return _vm.updateFile($event)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "buttons-container-custom" },
                            [
                              _c(
                                "div",
                                { staticStyle: { display: "flex" } },
                                [
                                  _c("CustomButton", {
                                    attrs: {
                                      label: _vm.$t("Download Materials"),
                                      width: "4.48438rem",
                                      "button-styling":
                                        _vm.customButtonStylesExtra
                                    },
                                    on: { buttonClick: _vm.handleExtraAction }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticStyle: { display: "flex" } },
                                [
                                  _c("CustomButton", {
                                    attrs: {
                                      label: _vm.$t("Cancel"),
                                      width: "2.74219rem",
                                      "button-color": "#FFF",
                                      "label-color": "var(--app-primary-base)",
                                      buttonStyling:
                                        _vm.customButtonStylesSecondary
                                    },
                                    on: {
                                      buttonClick: _vm.handleSecondaryAction
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("CustomButton", {
                                    attrs: {
                                      label: _vm.$t("Submit"),
                                      width: "2.74219rem",
                                      "button-styling":
                                        _vm.customButtonStylesMain
                                    },
                                    on: {
                                      buttonClick: function($event) {
                                        return _vm.handleMainAction(_vm.file)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.activeTabDialog === 1
                    ? _c("div", { staticClass: "table-buttons-custom" }, [
                        _c(
                          "div",
                          { staticClass: "table-custom" },
                          [
                            _c("Table", {
                              attrs: {
                                loading: _vm.loading,
                                headers: _vm.headersDialog,
                                items: _vm.history
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "flex-end"
                              }
                            },
                            [
                              _c("CustomButton", {
                                attrs: {
                                  buttonStyling:
                                    _vm.customButtonStylesSecondary,
                                  label: _vm.$t("Close")
                                },
                                on: { buttonClick: _vm.handleSecondaryAction }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("LoadingSpinner", {
                  attrs: {
                    active: _vm.loadingUpload,
                    "is-full-page": false,
                    color: "var(--app-primary-base)"
                  },
                  on: {
                    "update:active": function($event) {
                      _vm.loadingUpload = $event
                    }
                  }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("dialog-choice", {
        attrs: {
          isOpen: _vm.deleteDialogIsOpen,
          title: _vm.$t("DeleteMaterial"),
          content: _vm.$t("DeleteMaterialConfirmation"),
          mainActionLabel: _vm.$t("Confirm"),
          secondaryActionLabel: _vm.$t("Cancel"),
          icon: "mdi-delete",
          iconColor: "var(--app-primary-base)"
        },
        on: {
          mainAction: _vm.handleDelete,
          secondaryAction: function($event) {
            _vm.deleteDialogIsOpen = false
          }
        }
      }),
      _vm._v(" "),
      _c("dialog-choice", {
        attrs: {
          isOpen: _vm.discardChangesByTabChangeDialogIsOpen,
          title: _vm.$t("DiscardChanges"),
          content: _vm.$t("DiscardChangesByTabSwitchDialog"),
          mainActionLabel: _vm.$t("Confirm"),
          secondaryActionLabel: _vm.$t("Cancel"),
          icon: "mdi-delete",
          iconColor: "var(--app-primary-base)"
        },
        on: { mainAction: _vm.tabChange, secondaryAction: _vm.cancelTabChange }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ff4fa0a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ff4fa0a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/StockManagement/TableView.vue
// module id = null
// module chunks = 